/** @format */

import React, { useState } from "react";
import Tabs from "../../components/ui/Tabs";
import CreateMemberShip from "./CreateMemberShip";
import AddFollowup from "./AddFollowup";

const MembershipFollowup = ({
  userForm,
  userDetails,
  token,
  next,
  refetchEnq,
}) => {
  const tabs = ["Create Membership", "Add as Folloup"];
  const [activeTab, setActiveTab] = useState(tabs[0]);

  return (
    <div>
      <div className="grid-k my-4">
        <div className="flex-k">
          <Tabs
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            tabs={tabs}
            type="secondary"
          />
        </div>

        {activeTab === tabs[0] ? (
          <div>
            <CreateMemberShip
              userDetails={userDetails}
              userForm={userForm}
              token={token}
              next={next}
            />
          </div>
        ) : null}

        {activeTab === tabs[1] ? (
          <div>
            <AddFollowup
              userForm={userForm}
              userDetails={userDetails}
              refetchEnq={refetchEnq}
              token={token}
              next={next}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default MembershipFollowup;
